<mat-progress-spinner
  class="spinner"
  mode="indeterminate"
  *ngIf="!studentAccount">
</mat-progress-spinner>

<section *ngIf="studentAccount" class="profile-bank">
  <div class="profile-bank__amount">На вашем счету: <b>{{ student_amount }} {{ currencyStr }}</b></div>
  <br>
  <div class="account__transactions">
    <app-account-transactions
      [account]="studentAccount"
    ></app-account-transactions>
  </div>
</section>
